import React from 'react';
import { isMobile, TranslationKeys } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { WinPopup } from '../../games/keno/winPopup';
import useTranslation from '../../hooks/useTranslation';
import { kenoBetStore } from '../../store/kenoBetStore';
import MobileOpenedNumbers from '../mobileOpenedNumbers';

export const GameHolder = observer(({ children }) => {
  const { roundId, isShowMobileResult } = kenoBetStore;
  const t = useTranslation();
  return (
    <div className='keno-game-column'>
      <div className='keno-game-column-wrapper'>
        <div className='keno-game-holder'>
          <div
            className={`keno-content ${isShowMobileResult && isMobile() ? 'close-content' : ''}`}
          >
            {!isMobile() ? (
              <div className='keno-game-round-id'>
                <span className='keno-game-round-id-txt'>
                  {t(TranslationKeys.RoundId)}: {roundId}
                </span>
              </div>
            ) : null}
            {children}
            <div className='keno-game-closed-block'>
              <div className='keno-game-closed-block-inner'>
                {isMobile() ? <WinPopup /> : null}
                {isShowMobileResult && isMobile() ? <MobileOpenedNumbers /> : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
